import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import {
  CustomerDomainName,
  ApiEndPoint,
  ActivityToken,
} from "../GlobalData/GlobalData";
import { Tooltip, Whisper } from "rsuite";
function ActivityCard({ newActivityListing }) {
  console.log(newActivityListing);
  const [isLoading, setIsLoading] = useState(false);
  var Domainpath = CustomerDomainName();
  var navigation = useNavigate();
  const showDetail = (id) => {
    navigation(`/activity_details/${id}`);
  };
  return (
    <>

      {newActivityListing.map((item, index)=>(

<div className="hotel-bg" key={index}>
{/* <a to="#agentfare" className="agentfare-h" data-toggle="collapse"><i className="fa fa-eye"></i></a> */}

<div className="row">

    <div className="col-12 col-sm-4 col-md-3 col-lg-3">

        <a to="/hotelDetailPage">

            <img src={
                          Domainpath +
                          "/public/images/activites/" +
                          item.featured_image
                        } className="himg" alt="" />

        </a>

    </div>

    <div className="col-12 col-sm-8 col-md-6 col-lg-6">

        <h2 className="htitle">

            <a  onClick={() => showDetail(item.id)} >{item.title}</a>

        </h2>
        <p> {item.activity_content
                        ? item.activity_content.slice(0, 300)
                        : ""}</p>


                        {item.starts_rating === "" ? (
                          <div class='cat_star'>No Rating</div>
                        ) : ( 
                            <span className="rate">
                               {Array(item.starts_rating)
                              .fill(0)
                              .map((_, index) => (
                                <i
                                  style={{ color: '#fa5636' }}
                                  key={index}
                                  className='fa fa-star'
                                >
                                  
                                </i>
                              ))}
                            </span>
                        )}


        <span className="location">

            <i className="fa fa-map-marker"></i>{item.location}

        </span>

        <p>Dates: {item.activity_date}</p>

    </div>

    <div className="col-12 col-sm-12 col-md-3 col-lg-3 align-content-center">

        <div className="price">

        <span> From
        {item.currency_symbol} {item.sale_price}
        </span>

            <small>Activity Hours : {item.duration}</small>

        </div>

        <a  onClick={() => showDetail(item.id)}    className="book bb" >View Detail</a>

    </div>

</div>

</div>
      ))}


     








    </>
  );
}

export default ActivityCard;
